module.exports = __webpack_public_path__ + "static/gauti-selvaraj.03d9fa08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gauti-selvaraj.png
// module id = 151
// module chunks = 168707334958949